'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1App7 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module1,
    app: state.moduleData.data.module1.app7
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App7, _Component);

  function Module1App7() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App7);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App7.__proto__ || (0, _getPrototypeOf2.default)(Module1App7)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 7,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Recommended serves for grains, meat and dairy',
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      console.log(event);
      _this.props.changeItem(module, modtype, item, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module1App7, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'What about the other food groups?'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Grains'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Choose mostly whole grains, such as brown rice, oats and quinoa; and wholemeal/wholegrain/high cereal fibre varieties of bread, pasta, crispbreads and cereal foods, over highly processed, refined varieties.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Meats and alternatives'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Choose lean cuts of meat (beef, lamb, pork) and poultry as well as fish, eggs, nuts, seeds and legumes. These are our main sources of protein, and include an important nutrients such as iodine, iron, zinc, B12 vitamins and healthy fats. Aim to have a variety of meat and non-meat options from this food group.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Dairy and alternatives'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Milk, yoghurt, cheese and alternatives like fortified soy, rice and cereal milks provide us with calcium and protein and other important nutrients. Fortified means that the milk has added calcium. Look for fortified milk that has at least 100mg of calcium per 100ml of milk. Choose reduced fat options of these foods to limit excess kilojoules from saturated fat.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'As the focus of the Reboot Program is on fruit and vegetables, you can skip the other food groups. You can always read about them later or if you wish to continue and learn about recommended serves for grains, meats and dairy, then',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/module1', onClick: this.handleOnClick.bind(this, 1, this.state.types.extra, 1) },
              ' click here.'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module1App7;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module1App7;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App7.js
// module id = 1170
// module chunks = 0